import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/firebase/auth.service';
import { AESService } from 'src/app/APIservices/encryption/aes.service';
import { NavService } from '../services/nav.service';

@Injectable(
  {
  providedIn: 'root'
}
)
export class AdminGuard implements CanActivate {
  isLoggedIn: boolean ;
  items=[]
  constructor(private nav: NavService ,public authService: AuthService,
    public router: Router,private enc : AESService) {
       }
  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
    // Guard for user is login or not
    //let user = JSON.parse(localStorage.getItem('user'));
    if (this.enc.getItem('logvalue',true)==null) {
      
      return this.router.navigate(['/auth/login']);
      //return true
    }
  
    return true
  }
}
